module.exports = __webpack_public_path__ + "bd.no2.c5b7f36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bd.no2.jpg
// module id = YK60
// module chunks = 0